import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from "axios";
import { APIURI } from "../config";

import footerLogo from "./images/whitelogo.png";
import facebookLogo from "./images/white-fb.png";
import twitter from "./images/white-twitter.png";
import telegram from "./images/white-telegram.png";
import instaLogo from "./images/white-insta.png";
import linkedinLogo from "./images/white-linkedin.png";
import './HomeV2.css';
import { useRef, useEffect } from 'react';


// ── Utility: IntersectionObserver fade-up ─────────────────
function useFadeOnScroll(threshold = 0.12) {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.add('hv2-visible');
          observer.unobserve(el);
        }
      },
      { threshold }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [threshold]);
  return ref;
}


function Footer() {
  const columnsRef = useFadeOnScroll(0.08);
  const [email, setEmail] = useState();
  const [emailError, setEmailError] = useState();
  const [subscribeUs, setSubscribeUs] = useState(false);
  var validator = require("email-validator");

  const handleSubscribe = () => {
    if (!validator.validate(email)) {
      setEmailError(true);
      setSubscribeUs(false);
      setTimeout(() => setEmailError(false), 5000);
    } else {
      axios
        .put(`${APIURI}user-detail/landing-page/subscribe?email=${email}`)
        .then((res) => {
          setSubscribeUs(true);
          setEmailError(false);
          setEmail("");
          setTimeout(() => setSubscribeUs(false), 5000);
        })
        .catch((err) => {
          setEmailError(true);
          setSubscribeUs(false);
          setEmail("");
          setTimeout(() => setEmailError(false), 5000);
        });
    }
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    setSubscribeUs(false);
    setEmailError(false);
  };

  return (
    <footer className="hv2-footer" style={{ paddingTop: '80px' }}>
      <div className="hv2-container hv2-footer-container">
        <div className="hv2-footer-columns hv2-fade-up" ref={columnsRef}>
          <div className="hv2-footer-col">
            <div className="hv2-footer-logo">
              <div className="hv2-nav-logo">
                <img src={footerLogo} alt="Bit Happier" className="hv2-nav-logo-img" />
              </div>
            </div>
            <p className="hv2-footer-brand-text">Our web and mobile app helps people learn how to be happier by taking simple, actionable steps.</p>
            <p className="hv2-footer-brand-text">Learn more about Bit Happier by joining our communities on Twitter, Facebook, or Instagram.</p>
            <span style={{ fontWeight: "700", color: "white", marginTop: "1rem" }}>Join Our Community</span>
            <div className="d-flex flex-row mt-3 bithappier-community ">
              <a
                href="https://www.facebook.com/BitHappier/?ref=page_internal"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  className="me-2"
                  width={25}
                  src={facebookLogo}
                  alt=""
                  srcSet=""
                />
              </a>
              <a
                href="https://www.instagram.com/bithappier/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  className="mx-2"
                  width={25}
                  src={instaLogo}
                  alt=""
                  srcSet=""
                />
              </a>
              <a
                href="https://www.linkedin.com/company/64744522/admin/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  className="mx-2"
                  width={25}
                  src={linkedinLogo}
                  alt=""
                  srcSet=""
                />
              </a>
              <a
                href="https://twitter.com/bit_happier"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  className="mx-2"
                  width={25}
                  src={twitter}
                  alt=""
                  srcSet=""
                />
              </a>
              <a
                href="https://t.me/BitHappier"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  className="mx-2"
                  width={25}
                  src={telegram}
                  alt=""
                  srcSet=""
                />
              </a>
            </div>
          </div>
          <div className="hv2-footer-col">
            <div className="hv2-footer-header">ABOUT US</div>
            <ul className="d-flex flex-column footer-14-ul">
              <Link to="/aboutus/#ourteam" className="">
                Our Team
              </Link>
              <a href="/aboutus/#careers" className="">
                Careers
              </a>
              <Link to="/happinessresearch" className="">
                Bit Happier Lab
              </Link>
              <Link to="/tokenomics" className="">
                Tokenomics
              </Link>
              <a href="/tokenomics/#happinessdrops" className="">
                Happiness Drops
              </a>
            </ul>
          </div>

          {/* Links 1 */}
          <div className="hv2-footer-col">
            <div className="hv2-footer-header">Product</div>
            <ul className="d-flex flex-column footer-14-ul">
              <li><a href="#organisations" className="">For Organisations</a></li>
              <li><a href="#individuals" className="">For Individuals</a></li>
              <li><a href="#science" className="">The Science</a></li>
              <li><a href="#art-insights" className="">Art Insights</a></li>
            </ul>
          </div>


          <div className="hv2-footer-col">
            <div className="hv2-footer-header">Support</div>
            <ul className="d-flex flex-column footer-14-ul">
              {/* <Link to="/crisishelpline" className="mb-2">
                                    Crisis Helpline
                                  </Link> */}
              <Link to="/faq" className="">
                FAQ/Tutorials
              </Link>
              <Link to="/t&c" className="">
                Terms & conditions
              </Link>
              <Link to="/privacypolicy" className="">
                Privacy Policy
              </Link>
              <a href="/contact-us" className="">
                Contact Us
              </a>
              <Link to="/delete-your-account" className="">
                Delete Your Account
              </Link>
            </ul>
          </div>

          <div className="hv2-footer-col">
            {/* <div className=" mb-5">
              <h4 className='hv2-footer-logins'>Mental Wellness Professional Login</h4>
              <div className="d-flex flex-wrap gap-3">
                <Link to="/login#therapist">
                  <button className="hv2-btn hv2-btn-outline hv2-btn-sm">Login</button>{" "}
                </Link>
                <a
                  href="/wellnessprofessionaljoin"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <button className="hv2-btn hv2-btn-primary hv2-btn-sm">Join Us</button>
                </a>
              </div>
            </div> */}

            <span className='hv2-footer-subscribe'>
              Subscribe to our Happiness Newsletter
            </span>
            <div className="my-1">
              {subscribeUs === true ? (
                <span
                  style={{
                    color: "#FFF5F7",
                    fontFamily: "Inter",
                    fontSize: "21px",
                    fontWeight: "700",
                  }}
                >
                  Thank you for subscribing to us!
                </span>
              ) : (
                ""
              )}

              {emailError === true ? (
                <span
                  style={{
                    color: "#FFF5F7",
                    fontFamily: "Inter",
                    fontSize: "21px",
                    fontWeight: "700",
                  }}
                >
                  Please Enter The Valid Email
                </span>
              ) : (
                ""
              )}
            </div>

            <div className="d-flex flex-row gap-2 footer-subs flex-wrap mt-3">
              <input
                type="email"
                name=""
                className="footer-input me-2"
                value={email}
                onChange={handleEmailChange}
                placeholder="Enter Email Address"
                id=""
              />
              <button onClick={handleSubscribe} className="hv2-btn hv2-btn-primary hv2-btn-sm">
                Subscribe
              </button>
            </div>
          </div>
        </div>
        <div className="hv2-footer-bottom">
          <div className="hv2-footer-copy">&copy; {new Date().getFullYear()} Bit Happier Inc. All rights reserved.</div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;